/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ScheduledChangeSwapRequestReasonCode =
  (typeof ScheduledChangeSwapRequestReasonCode)[keyof typeof ScheduledChangeSwapRequestReasonCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledChangeSwapRequestReasonCode = {
  wrong_or_not_taught: 'wrong_or_not_taught',
  unclear: 'unclear',
  not_my_exam: 'not_my_exam',
  other: 'other',
  resource_not_exam_relevant: 'resource_not_exam_relevant',
} as const;
